import { View } from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import Toast from 'react-native-toast-message'
import SignatureFormView from '../SignatureFormView'

const CAonline = ({ navigation, route }: any) => {
  const {
    values,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey
  } = route.params

  const personalstore = usePersonalStore()
  const intializestore = useInitializeStore()

  const { loading, postcaonline } = useFormsStore()
  const handlesubmit = async (signatureDataURL: string) => {
    const data = {
      completeOnline: true,
      essUserKey: intializestore.initializeData.userkey,
      entityId: personalstore.personalData?.entityId,
      essUserOnBoardingFormKey: essUserOnBoardingFormKey,
      essObKey: essUserOnBoardingKey,
      filingStatus: values?.filingStatus ? values?.filingStatus : null,
      noOfReguralAllowances: values?.noOfRegularAllowances ? values?.noOfRegularAllowances : null,
      noOfEstimatedDeductions: values?.noOfEstimatedDeductions ? values?.noOfEstimatedDeductions : null,
      totalAllowances: Number(values?.noOfRegularAllowances) + Number(values?.noOfEstimatedDeductions),
      additionalAmount: values?.additionalAmount ? values?.additionalAmount : null,
      typeOfCertify: values?.typeofexemption ? values?.typeofexemption : null,
      sign: signatureDataURL
    }
    const response = await postcaonline(data)
    if (response?.success) {
      await Toast.show({
        type: 'success',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60,
        onHide: () => {
          navigation.replace('OnboardingForms')
        }
      })
    } else {
      await Toast.show({
        type: 'error',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60
      })
    }
  }

  return (
    <>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'CA Withholding Taxation'}
          />
        </View>
      </View>
      <SignatureFormView
        essUserOnBoardingFormKey={essUserOnBoardingFormKey}
        essUserOnBoardingKey={essUserOnBoardingKey}
        isSubmitting={loading}
        onPrevious={() =>
          navigation.navigate('CAinformationForm', {
            essUserOnBoardingFormKey,
            essUserOnBoardingKey,
            values,
            mode: "online",

          })
        }
        onSubmit={handlesubmit}
      />

    </>
  )
}
export default CAonline
